<template>
  <div class="float-right boss-batch-select">
    <select
      v-model="selectedTargetOption"
      class="boss-input-select"
    >
      <option
        v-for="(targetOption ,i) in targetOptions"
        :key="i"
        :data-test="'target-option-' + targetOption.key"
        :value="targetOption"
      >
        {{ targetOption.optionLabel }}
      </option>
    </select>
    <button
      :disabled="isDisabled"
      class="boss-button boss-exe-button pega-button"
      data-test="action-button"
      @click="doAction()"
    >
      <span
        class="boss-exe-button-text"
      >実行する</span>
    </button>
    <!-- ▼一括更新モーダル -->
    <div
      id="bulk-update-modal"
      class="reveal boss-modal-container pega-modal-position"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title pega-mb-25"
        data-test="modal-title"
      >
        {{ selectedTargetOption.name }}の一括更新
      </h1>
      <div class="boss-layout boss-layout-center">
        <div class="pega-bulk-update-container">
          <div data-test="modal-body">
            選択したすべての応募者の{{ selectedTargetOption.name }}を
          </div>
          <div>
            <select
              v-if="selectedTargetOption.inputType === 'select'"
              v-model="itemId"
              data-test="input-select"
              class="boss-input-select"
            >
              <option
                v-for="(itemOption ,i) in itemOptions"
                :key="i"
                :data-test="'item-option-' + itemOption.id"
                :value="itemOption.id"
              >
                {{ itemOption.name }}
              </option>
            </select>
            <textarea
              v-if="selectedTargetOption.inputType === 'textarea'"
              v-model="remarks"
              data-test="input-textarea"
              class="boss-send-textarea pega-textarea-resize-none"
            />
            <span>に</span>
          </div>
          <div class="text-center">
            <button
              class="boss-button-center boss-button-large pega-button pega-mx-10 pega-mt-10"
              type="button"
              data-test="update-button"
              @click="update"
            >
              更新する
            </button>
            <button
              class="boss-button-center boss-button-large pega-mx-10 pega-mt-10"
              type="button"
              data-test="cancel-button"
              @click="closeReveal()"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        @click="closeReveal()"
      />
    </div>
    <!-- ▲一括更新モーダル -->
  </div>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { downloadCSV, downloadPDF } from '@/lib/download'
import Indicator from '@/lib/indicator'
import cartInAnimation from '@/lib/cartInAnimation'

export default {
  props: {
    entryIds: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedTargetOption: _.head(definition.applicantBulkUpdate),
      itemOptionMap: {
        phases: () => { return this.phases },
        phaseStatuses: () => { return [{ id: '', name: '-' }, ...this.allStatuses] },
        responsibleStaffs: () => { return [{ id: '', name: '-' }, ...this.responsibles] }
      },
      itemId: '',
      remarks: ''
    }
  },
  computed: {
    targetOptions () {
      return definition.applicantBulkUpdate.filter(option => {
        if (option.permission === 'canPdfDownload') {
          return this.canPdfDownload
        } else if (option.permission === 'canSendMessage') {
          return this.canSendMessage
        } else {
          return true
        }
      })
    },
    isDisabled () {
      return _.isEmpty(this.entryIds)
    },
    itemOptions () {
      return _.get(this.itemOptionMap, _.camelCase(this.selectedTargetOption.key), () => {})()
    },
    firstIndexOfItemId () {
      return _.get(this.itemOptions, '[0].id', '')
    },
    isOverLengthRemarks () {
      return this.remarks.length > 500
    },
    ...mapGetters('settings', [
      'phases',
      'responsibles',
      'allStatuses',
      'fixedStatuses'
    ]),
    ...mapGetters([
      'canPdfDownload',
      'canSendMessage'
    ])
  },
  watch: {
    targetOptions: {
      handler (val) {
        this.$set(this, 'selectedTargetOption', _.head(val))
      },
      deep: true
    }
  },
  methods: {
    doAction () {
      if (this.selectedTargetOption.key === 'create_bulk_message') {
        this.$router.push({ name: 'applicantBulkMessage', params: { entryIds: this.entryIds } })
      } else if (this.selectedTargetOption.key === 'csv_download') {
        downloadCSV(this.entryIds)
      } else if (this.selectedTargetOption.key === 'pdf_download') {
        downloadPDF(this.entryIds)
      } else {
        if (!this.modal) {
          this.modal = new Foundation.Reveal(jQuery('#bulk-update-modal'), { closeOnClick: false })
        }
        this.initializeModalData()
        this.modal.open()
      }
    },
    closeReveal () {
      this.modal.close()
    },
    initializeModalData () {
      this.$set(this, 'itemId', this.firstIndexOfItemId)
      this.$set(this, 'remarks', '')
    },
    update () {
      const parameter = {
        entryIds: this.entryIds,
        itemId: this.itemId,
        remarks: this.remarks
      }
      Indicator.emitShow()
      this.$http.secured.put(`/entry/view/entries/${this.selectedTargetOption.key}`, _.omitBy(parameter, v => !_.isNumber(v) && _.isEmpty(v))).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: `${this.selectedTargetOption.name}を更新しました` })
        this.selectedTargetOption.isCartInAnimation && this.startCartInAnimation(this.itemId)
        this.$emit('updated')
      }).finally(() => {
        Indicator.emitHide()
        this.closeReveal()
      })
    },
    startCartInAnimation (statusId) {
      const targetElementId = _.includes(this.fixedStatuses.map(status => status.id), statusId)
        ? `#display-target-${statusId}` : ''
      // #applicant-applicantsの要素はapplicantTopのapplicant-applicantsコンポーネントをラップしているdivタグに付与されている
      targetElementId && cartInAnimation.start('#applicant-applicants', targetElementId)
    }
  }
}
</script>
